import { useSelector } from 'react-redux';
import { useAuthentication } from '../LoginPage';
import { FeatureType } from '@apply/constants';

const ExperienceUserRecommendationPanel = () => {
    const applicableProvidedExperienceCount = useSelector((state) => state.user?.applicableProvidedExperienceCount);
    const { isFeatureEnabled } = useAuthentication();

    const renderText = () => {
        if (applicableProvidedExperienceCount !== 1) {
            return <span>You have provided {applicableProvidedExperienceCount} entries, most applicants provide 20.</span>;
        } else {
            return <span>You have provided {applicableProvidedExperienceCount} entry, most applicants provide 20.</span>;
        }
    };

    if (!isFeatureEnabled(FeatureType.Experience)) {
        return null;
    }

    return <>{renderText()}</>;
};

export default ExperienceUserRecommendationPanel;
